(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-cookie-consent]');

    if (!banner || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return;
    }

    const preferences = banner.querySelector('[data-cookie-preferences]');
    const manageButton = banner.querySelector('[data-cookie-manage]');
    const acceptButton = banner.querySelector('[data-cookie-accept]');
    const declineButton = banner.querySelector('[data-cookie-decline]');
    const saveButton = banner.querySelector('[data-cookie-save]');
    const categoryInputs = banner.querySelectorAll('[data-consent-category]');
    const storageKey = 'gc-cookie-consent';

    const getPrivacyApi = () => window.Shopify && window.Shopify.customerPrivacy;

    const hasStoredConsent = () => {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (error) {
        return false;
      }
    };

    const rememberConsent = () => {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (error) {
        return;
      }
    };

    const forgetStoredConsent = () => {
      try {
        window.localStorage.removeItem(storageKey);
      } catch (error) {
        return;
      }
    };

    const showBanner = () => {
      banner.hidden = false;
      window.requestAnimationFrame(() => banner.classList.remove('is-hidden'));
    };

    const hideBanner = () => {
      banner.classList.add('is-hidden');
      banner.hidden = true;

      if (preferences) {
        preferences.hidden = true;
      }

      if (manageButton) {
        manageButton.setAttribute('aria-expanded', 'false');
      }
    };

    const setConsent = consent => {
      const privacyApi = getPrivacyApi();

      if (!privacyApi || typeof privacyApi.setTrackingConsent !== 'function') {
        return;
      }

      try {
        privacyApi.setTrackingConsent(consent, hideBanner);
      } catch (error) {
        return;
      }
    };

    const submitConsent = consent => {
      setConsent(consent);
      rememberConsent();
      hideBanner();
    };

    const consentStringToBoolean = value => value === 'yes';

    const readCurrentConsent = () => {
      const privacyApi = getPrivacyApi();

      if (!privacyApi || typeof privacyApi.currentVisitorConsent !== 'function') {
        return {};
      }

      try {
        return privacyApi.currentVisitorConsent() || {};
      } catch (error) {
        return {};
      }
    };

    const prefillPreferences = () => {
      const currentConsent = readCurrentConsent();

      categoryInputs.forEach(input => {
        input.checked = consentStringToBoolean(currentConsent[input.dataset.consentCategory]);
      });
    };

    const openPreferences = () => {
      if (!preferences || !manageButton) {
        return;
      }

      prefillPreferences();
      preferences.hidden = false;
      manageButton.setAttribute('aria-expanded', 'true');

      const firstInput = preferences.querySelector('[data-consent-category]');

      if (firstInput) {
        firstInput.focus({ preventScroll: true });
      }
    };

    if (acceptButton) {
      acceptButton.addEventListener('click', () => {
        submitConsent({
          analytics: true,
          marketing: true,
          preferences: true,
          sale_of_data: true,
        });
      });
    }

    if (declineButton) {
      declineButton.addEventListener('click', () => {
        submitConsent({
          analytics: false,
          marketing: false,
          preferences: false,
          sale_of_data: false,
        });
      });
    }

    if (manageButton && preferences) {
      manageButton.addEventListener('click', () => {
        const isExpanded = manageButton.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          preferences.hidden = true;
          manageButton.setAttribute('aria-expanded', 'false');
          return;
        }

        openPreferences();
      });
    }

    if (saveButton) {
      saveButton.addEventListener('click', () => {
        const consent = {};

        categoryInputs.forEach(input => {
          consent[input.dataset.consentCategory] = input.checked;
        });

        submitConsent(consent);
      });
    }

    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const opener = event.target.closest('[data-cookie-open]');

      if (!opener) {
        return;
      }

      event.preventDefault();
      forgetStoredConsent();
      showBanner();
      openPreferences();
    });

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          return;
        }

        const privacyApi = getPrivacyApi();

        if (!privacyApi || typeof privacyApi.shouldShowBanner !== 'function') {
          return;
        }

        try {
          if (privacyApi.shouldShowBanner() && !hasStoredConsent()) {
            showBanner();
          }
        } catch (apiError) {
          return;
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
